import Logo from "../../assets/images/logo.svg";
import MenuBar from "../../assets/images/icon-menu.svg";
import MenuBarClose from "../../assets/images/icon-menu-close.svg";
import "./index.scss";
import { useState } from "react";
export default function Header() {
  const [status, setStatus] = useState(false);
  return (
    <>
      <div className={`${status === true ? "background " : ""}`}></div>
      <div className="header">
        <div className="header__logo">
          <img src={Logo} alt="logo" />
        </div>
        <div className="header__menu">
          <button onClick={() => setStatus(true)}>
            <img src={MenuBar} alt="menu-bar" />
          </button>
        </div>
        <nav
          className={`header__navigation ${status === true ? "ModalOpen" : ""}`}
        >
          <div className="header__navigation__close">
            <button onClick={() => setStatus(false)}>
              <img src={MenuBarClose} alt="menu-bar-close" />
            </button>
          </div>
          <div className="header__navigation__list">
            <a href="www.google.com">Home</a>
            <a href="www.google.com">New</a>
            <a href="www.google.com">Popular</a>
            <a href="www.google.com">Trending</a>
            <a href="www.google.com">Categories</a>
          </div>
        </nav>
      </div>
    </>
  );
}
